import { render, staticRenderFns } from "./policyStage.vue?vue&type=template&id=345b8e7e&lang=pug"
import script from "./policyStage.vue?vue&type=script&lang=js"
export * from "./policyStage.vue?vue&type=script&lang=js"
import style0 from "./policyStage.vue?vue&type=style&index=0&id=345b8e7e&prod&lang=stylus&socped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports